export type MasterType = {
  id: number;
  name: string;
};

export const masterTypes: MasterType[] = [
  { id: 5, name: "Google Analytics 4" },
  { id: 2, name: "AD EBiS（媒体種別粒度）" },
  { id: 3, name: "AD EBiS（広告ID粒度）" },
];
